import React, { FC, ReactNode, useCallback, useRef, useState } from 'react';
import { Box, BoxProps } from '@mui/material';


import { DropdownPopper, DropdownPopperProps } from '../DropdownPopper';
import { FilterButton, FilterButtonProps } from '../FiilterButton';


export type DropdownFilterProps = FilterButtonProps & DropdownPopperProps & {
    text: ReactNode;
    containerProps?: Omit<BoxProps, 'ref'>;
};

export const useFilterOpenState = () => {
    const [isOpen, setOpen] = useState(false);

    const toggle = useCallback(() => {
        setOpen(!isOpen);
    }, [isOpen]);
    const close = useCallback(() => setOpen(false), []);

    return {
        isOpen,
        toggle,
        close,
    };
};

export const DropdownFilter: FC<DropdownFilterProps> = ({
    text,
    isOpen,
    close,
    children,
    containerProps,
    ...buttonProps
}) => {
    const containerRef = useRef<HTMLDivElement>();
    return (
        <Box ref={containerRef} {...containerProps}>
            <FilterButton
                isOpen={isOpen}
                {...buttonProps}
            >
                {text}
            </FilterButton>
            <DropdownPopper
                close={close}
                isOpen={isOpen}
                anchorEl={containerRef.current}
            >
                {children}
            </DropdownPopper>
        </Box>
    );
};
